import { useEffect, useState } from 'react';
import { HosApiDashboardSignage } from '../../types/apiTypes';
import { DashboardData } from '../../types/commonTypes';
import { useFetch } from '../useFetch';
import { useOperator } from '../../contexts/OperatorContext';
import { BASE_URL_MAP } from '../../lib/environment';

export const useSignageAnalytics = () => {
  const [signageAnalytics, setSignageAnalytics] = useState<DashboardData[]>([]);
  const { makeRequest, loading, response } = useFetch();
  const operator = useOperator();

  useEffect(() => {
    if (response) setSignageAnalytics(mapSignageAnalytics(response));
  }, [response]);

  const getSignageAnalytics = () => {
    makeRequest(
      `${BASE_URL_MAP['Hospitality']}/${operator?.id}/Dashboard/DigitalSignageSchedules`,
      'get'
    );
  };

  return { signageAnalytics, getSignageAnalytics, loading };
};

const mapSignageAnalytics = (
  metric: HosApiDashboardSignage
): DashboardData[] => {
  return [
    {
      id: 'Event Schedules',
      value: metric.EventCount,
    },
    {
      id: 'Players',
      value: metric.PlayerCount,
    },
  ];
};
